module.exports = __webpack_public_path__ + "static/media/IMG_2016.a5f4701c.jpg";